export default "__VITE_ASSET__Hn9wB6Ln__"